import React from 'react';
import { ProductInfo } from './ProductInfo';

export const DetailContent = () => {
	return (
		<div>
			<ProductInfo />
		</div>
	);
};
